import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { SuperEllipse as Icon } from '@alfalab/core-components-icon-view/super-ellipse';

import type { TSuperEllipse, IDepsSuperEllipse } from './models';
import { IconView as Component } from './icon-view';

export const IconViewSuperEllipse = createWidget<IDepsSuperEllipse, TSuperEllipse>(
    { Icon },
    { priorityStyler: true }
)(Component);
